import React from 'react';
// material-ui
import { Box, Grid, Typography } from '@mui/material';
// models
import { Condiments, FirstMenu, ItemUnit, MenuDish, SecondMenu, TaxGroup } from '../../models';
// component
import MenuDishDetailMultiple from './menu-dish-detail-multiple.component';
import { apiManage_rbp } from '../../request';
import _ from 'lodash';

import CommonInput from '../../component/form/common-input.component';
import i18n from '../../i18n';
import DishGroupDetail from './dish-group-detail';
import GlobalNotification from '../../component/common/snackbar';
import { PatchDishesParams } from '../../request/api/rbp/menu';
import Card from './Card';
import { SwitchComponent } from './dish-group-detail';
import { urlToFile } from '../../constants/tool-image';
import BASE_CHECK_TYPE from '../../constants/regular.constant';
import { ALLERGEN, INGREDIENTS } from '../../static/images/dish-base-data';
import ButtonComponent from '../../component/button/button.component';
import LSM from '../../modules/cache/tool-local-storage';
import { LOCAL_STORAGE_KEYS } from '../../modules/cache/local-storage.constant';

export default class ClassifyMenuDetail extends React.Component<Props, State> {
    // 是否意大利国家
    public isItaly = LSM.get(LOCAL_STORAGE_KEYS.RBP_RESTAURANT_COUNTRY) === 'Italy';
    // 修改菜名2
    public editDishName2 = false;
    public state: State = {
        // 模式 编辑菜品 批量编辑菜品
        mode: 'SINGLE',
        // 所属菜单 不同菜单的同一菜品
        dishes: [],
        // 详情
        detail: _.cloneDeep(this.props.detail) || {},
        // 菜品图片
        avatarUrl: '',
        // 大图
        avatarUrlMax: '',
        // 加载中
        isLoading: false,
        // 套餐区域详情弹窗
        isGroupOpen: false,
        // 是否更新关联菜品
        isUpdateChildDish: true,
    }
    // *********************
    // Life Cycle Function
    // *********************
    async componentDidMount() {
        await this.init()
    }
    // *********************
    // Default Function
    // *********************
    /**
     * 初始化
     */
    async init() {
        const detail = { ...this.props.detail };
        detail.special_attributes = detail?.special_attributes || 0
        if (detail.id || detail.id === 0) {
            const result = await apiManage_rbp.get_dishes(Number(detail.origin_id) || detail.id)
            if (!_.get(result, 'error')) {
                this.setState({
                    detail,
                    dishes: result,
                })
            }
        } else {
            detail.item_name1 = detail.item_name1 ?? i18n.t('menu_and_dishes_page_unnamed');
            detail.item_type = detail.item_type ?? 0;
            detail.price_1 = detail.price_1 ?? 0;
            detail.rule_lnr_max_num = detail.rule_lnr_max_num ?? 9999;
            detail.rule_table_max_num = detail.rule_table_max_num ?? 9999;
            detail.class_id = detail.class_id ?? 6;
            detail.required_condiment = detail.required_condiment || -1;
            detail.major_group = detail.major_group || -1;
            detail.family_group = detail.family_group || -1;
            detail.tax_group = detail.tax_group || -1;
            detail.print_class = detail.print_class || -1;
            this.setState({ detail })
        }
    }

    /**
     * 保存
     */
    async onSave() {
        try {
            let saveResult = false;
            const { isUpdateChildDish } = this.state;
            const detail = _.cloneDeep(this.state.detail);
            // 菜品名称和类型必填
            if (
                (!_.trim(detail.item_name1)) ||
                ((detail.item_type ?? '') === '')
            ) {
                throw i18n.t('input_rule_text_enter_dish_name_reuqired')
            }
            // 意大利--菜品名称1
            if (this.isItaly && !(BASE_CHECK_TYPE.dishNameAndNlu2.regular.test(detail.item_name1 ?? ''))) {
                throw i18n.t('input_rule_text_enter_dish_name_and_nlu_regular2')
            }
            // 意大利--菜品名称2
            if (this.isItaly && !(BASE_CHECK_TYPE.dishNameAndNlu.regular.test(detail.item_name2 ?? ''))) {
                throw i18n.t('input_rule_text_enter_dish_name_and_nlu_regular')
            }
            // 菜品名称，助记码校验
            if (
                !(BASE_CHECK_TYPE.dishNameAndNlu.regular.test(detail.nlu ?? ''))
            ) {
                throw i18n.t('input_rule_text_enter_dish_name_and_nlu_regular')
            }
            // 删除detail非数字库字段
            delete detail.slu_ids_arr;
            // 菜品详情
            let result;
            // 菜品图片
            // let imageResult;
            // 操作基础菜品
            let copyResult;
            detail.rule_lnr_limit_price = detail.rule_lnr_limit_price || 0;
            detail.rules_ignore_the_display = detail.rules_ignore_the_display || 0;
            detail.rule_lnr_limit_enable = detail.rule_lnr_limit_enable || 0;
            detail.unit_2 = detail.unit_2 || '';
            detail.unit_3 = detail.unit_3 || '';
            detail.unit_4 = detail.unit_4 || '';
            detail.unit_5 = detail.unit_5 || '';
            detail.price_1 = detail.price_1 || 0;
            detail.price_2 = detail.price_2 || 0;
            detail.price_3 = detail.price_3 || 0;
            detail.price_4 = detail.price_4 || 0;
            detail.price_5 = detail.price_5 || 0;
            detail.takeout_price_1 = detail.takeout_price_1 || 0;
            detail.takeout_price_2 = detail.takeout_price_2 || 0;
            detail.takeout_price_3 = detail.takeout_price_3 || 0;
            detail.takeout_price_4 = detail.takeout_price_4 || 0;
            detail.takeout_price_5 = detail.takeout_price_5 || 0;
            // 编辑
            if (detail.id) {
                const params: PatchDishesParams = {
                    id: detail.id,
                    item_name1: detail.item_name1 || '',
                    item_name2: detail.item_name2 || '',
                    item_type: detail.item_type,
                    nlu: detail.nlu || '',
                    rule_lnr_max_num: detail.rule_lnr_max_num,
                    rule_table_max_num: detail.rule_table_max_num,
                    rule_lnr_limit_price: detail.rule_lnr_limit_price,
                    item_description: detail.item_description || '',
                    ext_dish_info: detail.ext_dish_info || '',
                    // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                    allergen: Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                        String(detail.allergen) : detail.allergen?.join('*'),
                    other_detail_info: Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                        String(detail.other_detail_info) : detail.other_detail_info?.join('*'),
                    rules_ignore_the_display: detail.rules_ignore_the_display,
                    rule_lnr_limit_enable: detail.rule_lnr_limit_enable,
                    tax_group: detail.tax_group || -1,
                    required_condiment: detail.required_condiment || -1,
                    // 分配的二级菜单
                    slu_ids: detail.slu_ids || '',
                    // unit price takeout 1
                    unit_1: detail.unit_1,
                    price_1: detail.price_1,
                    takeout_price_1: detail.takeout_price_1,
                    // unit price takeout 2
                    unit_2: detail.unit_2,
                    price_2: detail.price_2,
                    takeout_price_2: detail.takeout_price_2,
                    // unit price takeout 3
                    unit_3: detail.unit_3,
                    price_3: detail.price_3,
                    takeout_price_3: detail.takeout_price_3,
                    // unit price takeout 4
                    unit_4: detail.unit_4,
                    price_4: detail.price_4,
                    takeout_price_4: detail.takeout_price_4,
                    // unit price takeout 5
                    unit_5: detail.unit_5,
                    price_5: detail.price_5,
                    takeout_price_5: detail.takeout_price_5,
                    item_ids: detail.item_ids || '',
                    print_class: detail.print_class || -1,
                    class_id: detail.class_id || 6,
                    special_attributes: detail.special_attributes || 0,
                }
                // 同步关联菜品 - 处理参数字段
                if (isUpdateChildDish) {
                    delete params.slu_ids;
                }
                result = await apiManage_rbp.patch_menu_library(params, isUpdateChildDish);
                // imageResult = await this.updateImage(`${detail.id}_s,${detail.id}`)
                // 操作基础菜品
                copyResult = await apiManage_rbp.patch_menu_library_to_menus({
                    menus_arr: [{
                        id: detail.id,
                        item_name1: detail.item_name1 || '',
                        item_name2: detail.item_name2 || '',
                        item_type: detail.item_type,
                        nlu: detail.nlu || '',
                        rule_lnr_max_num: detail.rule_lnr_max_num,
                        rule_lnr_limit_price: detail.rule_lnr_limit_price,
                        rule_table_max_num: detail.rule_table_max_num,
                        item_description: detail.item_description || '',
                        ext_dish_info: detail.ext_dish_info || '',
                        // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                        allergen: (
                            Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                                String(detail.allergen) : detail.allergen?.join('*')
                        ) as any,
                        other_detail_info: (
                            Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                                String(detail.other_detail_info) : detail.other_detail_info?.join('*')
                        ) as any,
                        rules_ignore_the_display: detail.rules_ignore_the_display,
                        rule_lnr_limit_enable: detail.rule_lnr_limit_enable,
                        tax_group: detail.tax_group || -1,
                        // unit price takeout 1
                        unit_1: detail.unit_1,
                        price_1: detail.price_1,
                        takeout_price_1: detail.takeout_price_1,
                        // unit price takeout 2
                        unit_2: detail.unit_2,
                        price_2: detail.price_2,
                        takeout_price_2: detail.takeout_price_2,
                        // unit price takeout 3
                        unit_3: detail.unit_3,
                        price_3: detail.price_3,
                        takeout_price_3: detail.takeout_price_3,
                        // unit price takeout 4
                        unit_4: detail.unit_4,
                        price_4: detail.price_4,
                        takeout_price_4: detail.takeout_price_4,
                        // unit price takeout 5
                        unit_5: detail.unit_5,
                        price_5: detail.price_5,
                        takeout_price_5: detail.takeout_price_5,
                        slu_ids: this.props.detail.slu_ids || '',
                        new_ids: detail.slu_ids || '',
                        item_ids: detail.item_ids || '',
                        required_condiment: detail.required_condiment || -1,
                        print_class: detail.print_class || -1,
                        special_attributes: detail.special_attributes || 0,
                    }],
                    slu_ids: detail.slu_ids?.split(',').map(n => Number(n)) || [],
                })
            }
            // 新增 - 单个
            else {
                // 参数做处理 过敏原和其他菜品标识要传字符串
                const params: PatchDishesParams[] = [{
                    ...detail,
                    item_name2: detail.item_name2 || detail.item_name1,
                    // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                    allergen: Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                        String(detail.allergen) : detail.allergen?.join('*'),
                    other_detail_info: Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                        String(detail.other_detail_info) : detail.other_detail_info?.join('*'),
                    required_condiment: detail.required_condiment || -1,
                    print_class: detail.print_class || -1,
                    tax_group: detail.tax_group || -1,
                    class_id: detail.print_class || 6,
                }]
                result = await apiManage_rbp.post_menu_library(params);
                const insertId = _.get(result, '[0]', null)
                detail.id = insertId;
                // imageResult = await this.updateImage(`${insertId}_s,${insertId}`);
                // 操作基础菜品
                copyResult = await apiManage_rbp.patch_menu_library_to_menus({
                    menus_arr: [{
                        ...detail,
                        item_name2: detail.item_name2 || detail.item_name1,
                        // ! 防止类型报错，可能与MenuDish中类型不一致！！！
                        allergen: (
                            Object.prototype.toString.call(detail.allergen) === '[object String]' ?
                                String(detail.allergen) : detail.allergen?.join('*')
                        ) as any,
                        other_detail_info: (
                            Object.prototype.toString.call(detail.other_detail_info) === '[object String]' ?
                                String(detail.other_detail_info) : detail.other_detail_info?.join('*')
                        ) as any,
                        slu_ids: this.props.detail.slu_ids || '',
                        new_ids: detail.slu_ids || '',
                    }],
                    slu_ids: detail.slu_ids?.split(',').map(n => Number(n)) || [],
                })
            }
            // 请求成功
            if (!_.get(result, 'error') && !_.get(copyResult, 'error')) {
                saveResult = true;
                // 批量更改目标图片
                // if (Array.isArray(copyResult) && copyResult.length > 0) {
                //     await Promise.all(copyResult?.map(itemId => {
                //         let api = this.updateImage(`${itemId}_s,${itemId}`)
                //         if (!avatarUrl) {
                //             api = apiManage_rbp.delete_dishes_image(itemId);
                //         }
                //         return api;
                //     })).then(values => {
                //         for (const value of values) {
                //             if (!value) {
                //                 GlobalNotification.error(i18n.t('menu_and_dishes_page_upload_failed'));
                //                 break;
                //             }
                //         }
                //     })
                // }
                // 刷新数据
                this.props.getMenuData();
                this.setState({
                    detail,
                    avatarFile: undefined,
                })
            }
            // 请求失败
            else {
                saveResult = false;
                throw i18n.t('global_text_operate_failure')
            }
            return saveResult
        }
        catch (error) {
            GlobalNotification.error(error as string)
            return;
        }
    }

    /**
     * 上传菜品图片
     */
    async updateImage(dishId: string) {
        let result = true;
        const { avatarFile, avatarUrl } = this.state;
        const blob = avatarFile ? avatarFile : await urlToFile(avatarUrl).catch(() => null)
        if (blob) {
            const imageResult = await apiManage_rbp.post_dishes_image(dishId, blob as File);
            // 上传失败
            if (_.get(imageResult, 'error')) {
                result = false;
            }
        }
        return result
    }

    /**
     * 表单回调
     * @param value
     * @param key
     */
    onChange(value: number | string | string[], key: string) {
        const { detail } = this.state;
        const propDetail = this.props.detail;
        let newValue = value;
        // 价格做处理
        if (
            (key === 'price_1') || (key === 'takeout_price_1') ||
            (key === 'price_2') || (key === 'takeout_price_2') ||
            (key === 'price_3') || (key === 'takeout_price_3') ||
            (key === 'price_4') || (key === 'takeout_price_4') ||
            (key === 'price_5') || (key === 'takeout_price_5') || (key === 'rule_lnr_limit_price')
        ) {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                newValue = Number(Number(value).toFixed(2))
            }
        }
        // 数量做处理
        if (key === 'rule_lnr_max_num' || key === 'rule_table_max_num') {
            if (value && Number(value) < 0) {
                newValue = 0
            }
            else if (value) {
                // 单人限点，以0.5为基数
                newValue = key === 'rule_lnr_max_num' ? Math.ceil(Number(value) / 0.5) * 0.5 : Number(Number(value).toFixed(0))
            }
        }
        // 分配菜单做处理
        if (key === 'slu_ids_arr') {
            key = 'slu_ids';
            newValue = newValue.toString();
        }
        _.set(detail, key, newValue);
        // 同步外卖价格
        if (key === 'price_1') !propDetail.takeout_price_1 && _.set(detail, 'takeout_price_1', newValue);
        if (key === 'price_2') !propDetail.takeout_price_2 && _.set(detail, 'takeout_price_2', newValue);
        if (key === 'price_3') !propDetail.takeout_price_3 && _.set(detail, 'takeout_price_3', newValue);
        if (key === 'price_4') !propDetail.takeout_price_4 && _.set(detail, 'takeout_price_4', newValue);
        if (key === 'price_5') !propDetail.takeout_price_5 && _.set(detail, 'takeout_price_5', newValue);
        if (key === 'item_name2' && !propDetail.item_id) this.editDishName2 = !!newValue
        // 同步菜名2
        if (!propDetail.id && key === 'item_name1') !this.editDishName2 && _.set(detail, 'item_name2', value);
        this.setState({
            detail
        })
    }

    /**
     * 删除菜品图片
     */
    async deleteImage() {
        const { detail, avatarFile } = this.state;
        if (detail.id) {
            if (avatarFile) {
                this.setState({
                    avatarUrl: '',
                    avatarUrlMax: '',
                    avatarFile: undefined
                })
            }
            else {
                // setLoading(true);
                // const result = await apiManage_rbp.delete_dishes_image(detail.id);
                // // 删除成功
                // if (result) {
                //     GlobalNotification.success(i18n.t('global_text_operate_success'));
                //     this.setState({
                //         avatarUrl: '',
                //         avatarUrlMax: ''
                //     })
                // }
                // else {
                //     GlobalNotification.error(i18n.t('global_text_operate_failure'));
                // }
                // setLoading(false);
            }

        }
        else {
            this.setState({
                avatarUrl: '',
                avatarUrlMax: '',
                avatarFile: undefined
            })
        }

    }

    /**
     * 保存按钮操作
     * @returns
     */
    async handleSave() {
        if (this.state.isLoading) {
            return;
        }
        this.setState({
            isLoading: true
        })
        const result = await this.onSave();
        if (result) {
            GlobalNotification.success(i18n.t('global_text_operate_success'))
            // 返回上一层
            this.props.handleClickBack()
        }
        this.setState({
            isLoading: false
        })

    }

    // /**
    //  * 编辑套餐区域
    //  */
    // async handleEditCourse() {
    //     if (this.state.isLoading) {
    //         return;
    //     }
    //     this.setState({
    //         isLoading: true
    //     }, async () => {
    //         const result = await this.onSave();
    //         this.setState({
    //             isLoading: false,
    //             isGroupOpen: !!result,
    //         })
    //     })
    // }

    renderMenuDishDetail = (): JSX.Element => {
        const { detail, isGroupOpen, isUpdateChildDish } = this.state;
        const _detail = _.cloneDeep(detail);
        const { sluMenus } = this.props;
        // 当前菜品所分配的二级菜单ids
        if (sluMenus) {
            const deSluIds: string[] = detail.slu_ids ?
                Array.from(new Set([...(detail?.slu_ids?.split?.(',') || [])])) : []
            _.set(detail, 'slu_ids_arr', deSluIds);
        }
        // 处理调味品、菜品标识字段
        if (Object.prototype.toString.call(_detail.allergen) === '[object String]') {
            const allergenArr = String(_detail.allergen)?.split('*');
            detail.allergen = allergenArr;
        }
        if (Object.prototype.toString.call(_detail.other_detail_info) === '[object String]') {
            const otDeInfoArr = String(_detail.other_detail_info)?.split('*');
            detail.other_detail_info = otDeInfoArr;
        }
        // 税率组
        const taxGroup = this.props.taxGroup?.map((item) => ({
            label: item.tax_group_name || '',
            value: item.tax_group_id || 0
        }));
        taxGroup.unshift({
            value: -1,
            label: i18n.t('menu_and_dishes_page_not_specified')
        })
        // 调味品组
        const condimentsGroup = this.props.condimentsGroup?.map((item) => ({
            label: item.comdiment_groups_name || '',
            value: item.scomdiment_groups_id || 0
        }));
        // 打印机组
        const printGroup = this.props.printGroup?.map((item) => ({
            label: item.print_class_name || '',
            value: item.print_class_id || 0
        }));
        // 菜品规格列表
        // const priceSpecList = this.props.priceSpecList.map((item) => ({
        //     label: item.unit_name || '',
        //     // ? value 暂定绑名称，因为聚客设置时写死
        //     value: item.unit_name || '',
        // }))
        // 表单
        const formArr1 = [
            {
                key: 'item_name1',
                label: i18n.t('business_analysis_page_dishes_name_one'),
                regularType: this.isItaly ? 'dishNameAndNlu2' : 'required',
                require: true,
            },
            {
                key: 'item_name2',
                label: i18n.t('business_analysis_page_dishes_name_two'),
                regularType: this.isItaly ? 'dishNameAndNlu' : undefined,
            },
            // ? 暂不支持套餐
            {
                key: 'item_type',
                label: i18n.t('menu_and_dishes_page_dish_type'),
                select: true,
                items: [
                    {
                        value: 0,
                        label: i18n.t('menu_and_dishes_page_normal_dishes'),
                    },
                    {
                        value: 2,
                        label: i18n.t('menu_and_dishes_page_dish_with_current_price'),
                    },
                    {
                        value: 4,
                        label: i18n.t('menu_and_dishes_page_custom'),
                    },
                    {
                        value: 5,
                        label: i18n.t('menu_and_dishes_page_text'),
                    },
                ],
                require: true,
                regularType: 'required',
            },
            {
                key: 'tax_group',
                label: i18n.t('tax_group_page_label'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: taxGroup,
            },
            {
                key: 'print_class',
                label: i18n.t('menu_and_dishes_page_print_class'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: printGroup,
            },
            {
                key: 'nlu',
                label: i18n.t('rwa_setting_page_mnemonic_code'),
                regularType: 'dishNameAndNlu',
            },
        ]
        // 表单
        const formArr2 = [
            // {
            //     key: 'unit_1',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 1`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            {
                key: 'price_1',
                label: `${i18n.t('menu_and_dishes_page_price')}`,
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'takeout_price_1',
                label: `${i18n.t('menu_and_dishes_page_takeout_price')}`,
                width: 4 as const,
                type: 'number'
            },
            // {
            //     key: 'unit_2',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 2`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_2',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 2`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_2',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 2`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'unit_3',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 3`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_3',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 3`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_3',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 3`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'unit_4',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 4`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_4',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 4`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_4',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 4`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'unit_5',
            //     label: `${i18n.t('menu_and_dishes_page_dish_specification')} 5`,
            //     width: 4 as 4,
            //     select: true,
            //     items: priceSpecList,
            //     allowClear: true,
            // },
            // {
            //     key: 'price_5',
            //     label: `${i18n.t('menu_and_dishes_page_price')} 5`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            // {
            //     key: 'takeout_price_5',
            //     label: `${i18n.t('menu_and_dishes_page_takeout_price')} 5`,
            //     width: 4 as 4,
            //     type: 'number'
            // },
            {
                key: 'rule_lnr_max_num',
                label: i18n.t('menu_and_dishes_page_rule_lnr_max_num'),
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'rule_table_max_num',
                label: i18n.t('menu_and_dishes_page_table_max_num'),
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'class_id',
                label: i18n.t('menu_and_dishes_page_menu_dish_has_discount'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: [
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 6 },
                    { label: i18n.t('menu_and_dishes_page_has_not_discount'), value: 3 }
                ],
            },
            {
                key: 'rule_lnr_limit_price',
                label: i18n.t('menu_and_dishes_page_extra_price'),
                width: 4 as const,
                type: 'number'
            },
            {
                key: 'required_condiment',
                label: i18n.t('condiment_page_group_optional'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: condimentsGroup,
            },
            {
                key: 'special_attributes',
                label: i18n.t('menu_and_dishes_page_special_attribute'),
                width: 4 as const,
                type: 'select',
                select: true,
                items: [
                    { label: i18n.t('print_setting_page_none0'), value: 0 },
                    { label: i18n.t('menu_and_dishes_page_chef_recommendation'), value: 1 },
                    { label: i18n.t('menu_and_dishes_page_new_menu_recommendation'), value: 2 },
                    { label: i18n.t('menu_and_dishes_page_has_discount'), value: 3 }
                ],
            },
            {
                key: 'item_description',
                label: i18n.t('google_text_dish_remarks'),
                width: 12 as const,
            },
            {
                key: 'ext_dish_info',
                label: i18n.t('menu_and_dishes_page_other_dish_mark'),
                width: 12 as const,
            },
            {
                key: 'allergen',
                label: i18n.t('menu_and_dishes_page_allergen'),
                width: 12 as const,
                inputType: 'SELECT_MUL' as const,
                options: ALLERGEN.map((item: any) => ({
                    value: item.key,
                    label: i18n.t(item.text),
                    icon: <img style={{ width: 20, height: 20 }} alt={item.key} src={item.icon} />
                }))
            },
            {
                key: 'other_detail_info',
                label: i18n.t('menu_and_dishes_page_other_dish_pin'),
                width: 12 as const,
                inputType: 'SELECT_MUL' as const,
                options: INGREDIENTS.map((item: any) => ({
                    value: item.key,
                    label: i18n.t(item.text),
                    icon: <img style={{ width: 20, height: 20 }} alt={item.key} src={item.icon} />
                }))
            },
            {
                key: 'slu_ids_arr',
                label: i18n.t('menu_and_dishes_page_distribute_menu'),
                width: 12 as const,
                inputType: 'SELECT_MUL' as const,
                allowClear: true,
                options: sluMenus.map((item) => ({
                    value: String(item.dmi_slu_id),
                    label: item.first_menu_name ? `${item.first_menu_name} - ${item.dmi_slu_name}` : item.dmi_slu_name as string,
                    icon: <></> as any,
                })),
                fullSelect: true
            },
        ]

        return (
            <div>
                <Card
                    title={(
                        <Box display='flex' alignItems='center'>
                            <ButtonComponent
                                action='BACK'
                                handleClick={() => {
                                    this.props.handleClickBack()
                                }}
                            />
                            <Typography>
                                {(detail.id || (detail.id === 0)) ? i18n.t('menu_and_dishes_page_edit_dish') : i18n.t('menu_and_dishes_page_add_dish')}
                            </Typography>
                        </Box>
                    )}
                    actionRender={(
                        <>
                            {/* {
                                detail.item_type === 3 &&
                                <ButtonComponent
                                    titleText='编辑套餐区域'
                                    children={<PlaylistAdd />}
                                    handleClick={() => {
                                        this.handleEditCourse();
                                    }}
                                />
                            } */}
                            <SwitchComponent
                                value={isUpdateChildDish}
                                label={i18n.t('menu_and_dishes_page_update_combine_dish')}
                                onChange={(e, checked) => {
                                    this.setState({
                                        isUpdateChildDish: checked,
                                    })
                                }}
                            />
                            <ButtonComponent
                                action='SAVE'
                                handleClick={async () => { await this.handleSave() }}
                            />
                        </>
                    )}
                    contentRender={(
                        <Grid container spacing={2} >
                            {/* <Grid item>
                                <AvatarCard
                                    avatarUrl={avatarUrl}
                                    avatarUrlMax={avatarUrlMax}
                                    onChangeAvatarUrl={(url, file) => {
                                        this.setState({
                                            avatarUrl: url,
                                            avatarUrlMax: url,
                                            avatarFile: file
                                        })
                                    }}
                                    onDelete={() => {
                                        this.deleteImage()
                                    }}
                                />
                            </Grid> */}
                            <Grid container item xs={12} spacing={4}>
                                {
                                    formArr1.map((item, index) => (
                                        <Grid container item xs={12} md={4} key={index}  >
                                            <CommonInput
                                                type={item.type}
                                                select={item.select}
                                                items={item.items}
                                                required={item.require}
                                                regularType={item.regularType}
                                                variant={'outlined'}
                                                fullWidth
                                                label={item.label}
                                                value={_.get(detail, item.key) ?? ''}
                                                onChange={(event: any) => {
                                                    this.onChange(event.target.value, item.key)
                                                }}
                                            />
                                        </Grid>
                                    ))
                                }
                                {
                                    formArr2.map((item, index) => {
                                        const onChange = (value: any) => {
                                            if (item.inputType === 'SELECT_MUL') {
                                                const newValue = value.map((item: any) => (item.value))
                                                this.onChange(newValue, item.key)
                                            }
                                            else {
                                                this.onChange(value.target.value, item.key)
                                            }
                                        }
                                        const selectValue: any[] = [];
                                        if (item.inputType === 'SELECT_MUL') {
                                            const v: string[] = _.get(detail, item.key, []);
                                            item.options.forEach((iitem) => {
                                                if (iitem.value && v && v.includes(iitem.value)) {
                                                    selectValue.push(iitem);
                                                }
                                            })
                                        }
                                        return (
                                            <Grid item xs={12} md={item.width} key={index}>
                                                <CommonInput
                                                    type={item.type}
                                                    select={item.select}
                                                    items={item.items}
                                                    inputType={item.inputType}
                                                    variant={'outlined'}
                                                    fullWidth
                                                    label={item.label}
                                                    value={item.inputType === 'SELECT_MUL' ? selectValue : (_.get(detail, item.key) ?? '')}
                                                    multipleProps={{
                                                        options: item.options as any,
                                                        onChange,
                                                        fullSelect: item.fullSelect
                                                    }}
                                                    onChange={onChange}
                                                    allowClear={item.allowClear}
                                                />
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                        </Grid>)
                    }
                />
                {
                    isGroupOpen &&
                    <DishGroupDetail
                        menuData={this.props.menuData}
                        dishDetail={this.state.detail}
                        open={isGroupOpen}
                        onCancel={() => {
                            this.setState({
                                isGroupOpen: false
                            })
                        }}
                    />
                }
            </div>
        )
    }
    // *********************
    // View
    // *********************

    render() {
        const { mode, dishes } = this.state;
        console.log('this.props.detail', this.props.detail)
        return (
            <Box marginTop='18px'>
                {
                    mode === 'SINGLE' ?
                        this.renderMenuDishDetail()
                        :
                        <MenuDishDetailMultiple
                            handleChangeMode={() => {
                                this.setState({
                                    mode: 'SINGLE'
                                })
                            }}
                            dishes={dishes}
                            {
                            ...this.props
                            }
                        />
                }
            </Box>
        )
    }
}

// *********************
// Type
// *********************
type Props = {
    // 菜品详情
    detail: MenuDish;
    // 返回
    handleClickBack: () => void;
    // 刷新菜单数据
    getMenuData: () => void;
    // 更新当前显示的菜品详情
    updateDetail: (detail: MenuDish) => void;
    // 税率组
    taxGroup: TaxGroup[]
    // 菜单数据
    menuData: FirstMenu[];
    // 调味品组
    condimentsGroup: Condiments[];
    // 打印组
    printGroup: any[];
    // 二级菜单
    sluMenus: (SecondMenu & { first_menu_name?: string })[];
    // 菜品规格列表
    priceSpecList: ItemUnit[];
}
type State = {
    // 模式 编辑菜品 批量编辑菜品
    mode: 'SINGLE' | 'MULTIPLE';
    // 所属菜单 不同菜单的同一菜品
    dishes: MenuDish[];
    // 菜品详情
    detail: MenuDish
    // 菜品图片
    avatarUrl: string;
    // 大图
    avatarUrlMax: string;
    // 菜品图片文件
    avatarFile?: File;
    // 加载中
    isLoading: boolean;
    // 套餐区域详情弹窗
    isGroupOpen: boolean;
    // 是否更新关联菜品
    isUpdateChildDish: boolean;
}